import { useEffect, useRef } from "react";
import { useRecoilValue } from "recoil";

import {
  disableFullTranslations,
  enableFullTranslations,
  i18nInitializedInstance,
  isLoggedInAtom,
} from "@ryde/shared";

import { getFullTranslationsChange } from "./full-translations-session.utils";

/** The full catalogue follows the session: loaded when it starts, dropped from memory and cache on logout. */
export const useFullTranslationsSession = (): void => {
  const isLoggedIn = useRecoilValue(isLoggedInAtom);
  const wasLoggedInRef = useRef(isLoggedIn);

  useEffect(() => {
    const change = getFullTranslationsChange({
      wasLoggedIn: wasLoggedInRef.current,
      isLoggedIn,
    });
    wasLoggedInRef.current = isLoggedIn;

    if (change === "enable") {
      void enableFullTranslations(i18nInitializedInstance);
    }

    if (change === "disable") {
      disableFullTranslations(i18nInitializedInstance);
    }
  }, [isLoggedIn]);
};
